// used to validate the size of file using Promise

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  methods: {
    validateFileSize(file, sizeLimit = 25) {
      // if(file.type === 'video/mp4')
      //   {
      //     sizeLimit = 5
      //   }
      // else
      //   {
      //     sizeLimit = 5
      //   }
      return new Promise((resolve, reject) => {
        if (file) {
          const size = (file.size / 1024 / 1024).toFixed(2);
          console.log("size" , size)
          console.log("sizeLimit" , sizeLimit)
          if (size > sizeLimit) {
            reject();
            let mes = `"حجم الملف يجب ألاّ يتجاوز ${sizeLimit} ميغا !"`
            this.$toast({
              component: ToastificationContent,
              props: {
                title: mes,
                icon: "ImageIcon",
                variant: "danger",
                timeout: 6000,
              },
            });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
  },
};
